// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '1.0',  

  // For Dev Deployment
  // env: 'dev',
  // tenant: '39a4d740-3930-48a3-9ce2-5a0e944847dc',
  // clientId: '26e726a1-cb3c-4d0d-8547-7b3a8b1970b3',
  // endpoints: { "https://authentixdevapi.azurewebsites.net/": "26e726a1-cb3c-4d0d-8547-7b3a8b1970b3" },
  // APIUrl: 'https://authentixdevapi.azurewebsites.net/',
  // MIMSAPIUrl: 'https://dev-mims-app-api.azurewebsites.net/',
  
  // For QA Deployment
  // env: 'qa',
  // tenant: '39a4d740-3930-48a3-9ce2-5a0e944847dc',
  // clientId: 'efb64806-09f8-4c35-bc4c-bb9bdb26c83b',
  // endpoints: { "https://qa-iqp-app-api-us.azurewebsites.net/": "efb64806-09f8-4c35-bc4c-bb9bdb26c83b" },
  // APIUrl: 'https://qa-iqp-app-api-us.azurewebsites.net/',
  // MIMSAPIUrl: 'https://qa-mims-app-api.azurewebsites.net/',

  // For Stage Deployment
  // env: 'stage',
  // tenant: '4b36e267-0463-40be-a48c-c3a22fa89c32',
  // clientId: '189ecaf9-8d9d-4538-a63e-ffcc97efee36',
  // endpoints: { "https://stage-iqp-app-api-us.azurewebsites.net/": "189ecaf9-8d9d-4538-a63e-ffcc97efee36" },
  // APIUrl: 'https://stage-iqp-app-api-us.azurewebsites.net/',
  // MIMSAPIUrl: 'https://stage-mims-app-api-us.azurewebsites.net/',

  // For Prod Deployment
  env: 'prod',
  tenant: '4b36e267-0463-40be-a48c-c3a22fa89c32',
  clientId: '189ecaf9-8d9d-4538-a63e-ffcc97efee36',
  endpoints: { "https://prod-iqp-app-api-us.azurewebsites.net/": "189ecaf9-8d9d-4538-a63e-ffcc97efee36" },
  APIUrl: 'https://prod-iqp-app-api-us.azurewebsites.net/',
  MIMSAPIUrl: 'https://prod-mims-app-api-us.azurewebsites.net/',

  redirectUri: window.location.origin,
  cacheLocation: 'localStorage',
  interval: 30000,
  SiteURL : window.location.origin,
  GoogleAPIKey : 'AIzaSyBULh9acaKKApxAJi6scTWtGetH8C-JSRo',
  powerbiReportURl : 'https://app.powerbi.com/reportEmbed?reportId=',
  powerbiDashboardURl : 'https://app.powerbi.com/dashboardEmbed?dashboardId=',
  powerbiTileURl : 'https://app.powerbi.com/embed?dashboardId='
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
